import {
    ACTIVITY_NEW_LOGS,
    ACTIVITY_OLD_LOGS,
    ACTIVITY_CACHE_TIME
} from './mutation-types'

import { structure } from './state'
import $ from 'jquery'
import _ from 'lodash'

const build = (node, payload, type) => {
    let id = payload.hash
    
    if(!node.logs[id])
        node.logs[id] = structure()
    
    node.lastCalled = id
    node.newLogs = payload.newLogs || ''
    node.oldLogs = payload.oldLogs || ''
    
    node.logs[id].lastCall = $.now()
    
    if(payload.logs.length) {
        if(type === 'new') {
            node.logs[id].newLogs = payload.logs[0].timeStamp+1
            node.logs[id].data = [...payload.logs, ...node.logs[id].data]
            
            // initial load
            if(node.logs[id].oldLogs === '') {
                node.logs[id].oldLogs = _.last(payload.logs).timeStamp-1
                node.logs[id].noOldLogs = node.oldLogs === ''
            }
        }
        else {
            node.logs[id].noOldLogs = node.oldLogs === ''
            node.logs[id].oldLogs = _.last(payload.logs).timeStamp-1
            node.logs[id].data = [...node.logs[id].data, ...payload.logs]
        }
        
        node.logs[id].data = _.uniqBy(node.logs[id].data, (e) => {
            return e.id
        })
    }
    else if(type !== 'new')
        node.logs[id].noOldLogs = node.oldLogs === ''
    
    if(payload.members)
        node.members = _.assign(node.members, payload.members)
    
    node.cacheTime = 30000
}

export default {
    [ACTIVITY_NEW_LOGS](state, payload) {
        build(state, payload, 'new')
    },
    
    [ACTIVITY_OLD_LOGS](state, payload) {
        build(state, payload, 'old')
    },
    
    [ACTIVITY_CACHE_TIME](state, payload) {
        state.cacheTime = payload.cacheTime
    }
}
